import FAQBase from "./FAQBase"

const CustomerFAQs = () => {
  return <FAQBase title="Customer FAQs" faqType="Customer" />
}

export default CustomerFAQs
